import React, { useState } from 'react';
import './VenueAnalysisGrid.scss';
import { VenueAnalysisData } from '../venueAnalysisAggregatedData';
import { MarketVolBreakdown } from './MarketVolBreakdown';
import { OrderVenueBreakdown } from './OrderVenueBreakdown';
import {
    toggleVenueAnalysisConfigProperty,
    VenueAnalysisVisibleSections,
    VenueAnalysisConfigurationState,
} from '../store/configuration/VenueAnalysisConfigurationState';
import { OrderLiquidityBreakdown } from 'widgets/venueAnalysis/grid/OrderLiquidityBreakdown';
import {
    isVenueSelected,
    VenueAnalysisSelection,
} from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';
import { HighlightedVenue } from 'widgets/venueAnalysis/highlighting';
import classNames from 'classnames';
import { usePortfolioStreamedOrSelectedSymbolFromOrders } from 'portfolio/store/hooks';

export interface VenueAnalysisGridProps {
    data?: VenueAnalysisData;
    config: VenueAnalysisConfigurationState;
    onConfigChange: (
        configuration: Partial<VenueAnalysisConfigurationState>
    ) => void;
    selection?: VenueAnalysisSelection;
    onChangeSelection: (value?: VenueAnalysisSelection) => void;
    widgetKey: string;
    height: number;
    width: number;
}

export default function VenueAnalysisGrid({
    data,
    config,
    height,
    onConfigChange,
    selection,
    onChangeSelection,
    widgetKey,
    width,
}: VenueAnalysisGridProps) {
    const toggleSection = (property: keyof VenueAnalysisVisibleSections) =>
        onConfigChange(toggleVenueAnalysisConfigProperty(config, property));

    const showOrderData = !!usePortfolioStreamedOrSelectedSymbolFromOrders();

    const [highlightedVenue, setHighlightedVenue] = useState<
        HighlightedVenue | undefined
    >(undefined);

    const classes = classNames(
        'VenueAnalysisGrid',
        isVenueSelected(selection) && 'venue-selected'
    );

    const style = { height };

    return (
        <div className={classes} style={style}>
            <MarketVolBreakdown
                data={data ?? {}}
                config={config}
                onToggle={() => toggleSection('market')}
                highlightedVenue={highlightedVenue}
                onHighlightedVenueChange={setHighlightedVenue}
                selection={selection}
                onChangeSelection={onChangeSelection}
                widgetKey={widgetKey}
                width={width}
            />
            {showOrderData && (
                <>
                    <OrderVenueBreakdown
                        data={data ?? {}}
                        config={config}
                        onToggle={() => toggleSection('orders')}
                        highlightedVenue={highlightedVenue}
                        onHighlightedVenueChange={setHighlightedVenue}
                        selection={selection}
                        onChangeSelection={onChangeSelection}
                        widgetKey={widgetKey}
                        width={width}
                    />
                    <OrderLiquidityBreakdown
                        data={data ?? {}}
                        config={config}
                        selection={selection}
                        width={width}
                    />
                </>
            )}
        </div>
    );
}
